import * as types from './types';
import { loading } from 'State/actions';

export const getDemographicsReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.DEMOGRAPHICS_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/Demographics',
        data
      );
      dispatch({
        type: types.DEMOGRAPHICS_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.DEMOGRAPHICS_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.DEMOGRAPHICS_REPORT_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.DEMOGRAPHICS_REPORT_GET_REPORT,
    payload: null,
  };
};

export const getSiteGroupsAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.DEMOGRAPHICS_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('sitegroup');
      dispatch({
        type: types.DEMOGRAPHICS_REPORT_GET_SITE_GROUPS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.DEMOGRAPHICS_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.DEMOGRAPHICS_REPORT_FETCHING, false));
  };
};

export const getGradesAction = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.DEMOGRAPHICS_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric('grade');
      dispatch({
        type: types.DEMOGRAPHICS_REPORT_GET_GRADES,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: types.DEMOGRAPHICS_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.DEMOGRAPHICS_REPORT_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/demographics/state/demographicsreport/actions.js